import { render, staticRenderFns } from "./search-tag.vue?vue&type=template&id=60011886"
import script from "./search-tag.vue?vue&type=script&lang=ts"
export * from "./search-tag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports